import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Dog } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export default function PuppotoAuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL hash
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        console.error('No session_id found in URL');
        navigate('/puppoto', { replace: true });
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        // Exchange session_id for session token
        const response = await fetch(`${API_URL}/api/puppoto/auth/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId })
        });

        if (!response.ok) {
          throw new Error('Auth failed');
        }

        const userData = await response.json();
        
        // Clear the hash from URL
        window.history.replaceState(null, '', '/puppoto/profile');
        
        // Navigate to profile with user data
        navigate('/puppoto/profile', { 
          replace: true,
          state: { user: userData }
        });

      } catch (error) {
        console.error('Auth error:', error);
        navigate('/puppoto', { replace: true });
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 bg-gradient-to-br from-[#FF7555] to-[#E5684A] rounded-2xl flex items-center justify-center mx-auto mb-4 animate-pulse">
          <Dog className="w-8 h-8 text-white" />
        </div>
        <p className="text-[#7A7571]">Signing you in...</p>
      </div>
    </div>
  );
}
